import {
  SurveyValidator,
  SurveyValidatorResult
} from 'core/builder/validators/SurveyValidator'

export class SurveyValidatorElementNames extends SurveyValidator {
  result(): Promise<SurveyValidatorResult[]> {
    const flatElementsName = this.survey.pages.flatMap((page) =>
      page.elements.map((el) => `${page.name}.${el.name}`)
    )
    const duplicates = flatElementsName.filter(
      (elementName, index, elements) => index !== elements.indexOf(elementName)
    )
    return Promise.resolve(
      duplicates.map((elPath) => {
        const [name, element] = elPath.split('.')
        return {
          pageName: name,
          elementName: element,
          level: 'ERROR',
          description: 'Element name duplicate'
        }
      })
    )
  }
}
